import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_BASE } from '../../lib/api';

const API = API_BASE;

const AdminLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await axios.post(`${API}/admin/login`, { username, password });
      localStorage.setItem('adminToken', res.data.token);
      navigate('/admin/dashboard');
    } catch {
      setError('Credenciales inválidas. Por favor verifica usuario y contraseña.');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#0F1C2E] flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-10">
          <div className="w-16 h-16 bg-[#7D468C] mx-auto mb-4 flex items-center justify-center" style={{ transform: 'rotate(45deg)' }}>
            <div className="w-8 h-8 bg-white/20" style={{ transform: 'rotate(-45deg)' }} />
          </div>
          <h1 className="font-poppins font-black text-3xl text-white">MIKEL <span className="text-[#7D468C]">MEDIA</span></h1>
          <p className="text-white/40 text-sm mt-2 font-source-sans">Panel de Administración</p>
        </div>

        <form onSubmit={handleLogin} className="bg-[#1A2639] p-8 border border-white/8">
          <h2 className="font-poppins font-bold text-xl text-white mb-6">Iniciar Sesión</h2>

          {error && (
            <div className="bg-red-500/10 border border-red-500/25 text-red-400 px-4 py-3 mb-5 text-sm font-source-sans" data-testid="login-error">
              {error}
            </div>
          )}

          <div className="mb-4">
            <label className="block text-white/50 text-sm font-source-sans mb-2">Usuario</label>
            <input
              type="text"
              value={username}
              onChange={e => setUsername(e.target.value)}
              data-testid="admin-username-input"
              className="w-full bg-[#0F1C2E] border border-white/10 text-white px-4 py-3 text-sm focus:outline-none focus:border-[#7D468C] transition-colors font-source-sans"
              placeholder="admin"
              required
            />
          </div>

          <div className="mb-7">
            <label className="block text-white/50 text-sm font-source-sans mb-2">Contraseña</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              data-testid="admin-password-input"
              className="w-full bg-[#0F1C2E] border border-white/10 text-white px-4 py-3 text-sm focus:outline-none focus:border-[#7D468C] transition-colors font-source-sans"
              placeholder="••••••••"
              required
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full bg-[#7D468C] text-white py-3 font-poppins font-bold text-sm uppercase tracking-wide hover:bg-[#9D62AD] transition-colors disabled:opacity-50"
          >
            {loading ? 'Cargando...' : 'Entrar'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
